import type { LoadWorkingOrderAction } from "actions/working-order-state";
import { WORKING_ORDER } from "constants/action-types";
import { getCompanyWarehouses } from "helpers/inventory";
import _ from "lodash";
import type { Dispatch } from "react-redux";
import type { IStore } from "reducers";

export const loadInventory =
    (productIds: string[], meta: { loadCart?: LoadWorkingOrderAction["payload"]; notifyCart?: boolean }) =>
    (dispatch: Dispatch<{}>, getState: () => IStore) => {
        const { working, scope, cart } = getState();

        let replenishmentLineItems = working.order.payload?.line_items;
        if (!cart?.isBulkOrder) {
            // We need to fetch product replenishments only when there are multiple lineItems refered to the same product,
            // otherwise we will use data from product availability. Bulk order requires all replenishments to be fetched
            const counts = _.countBy(working.order.payload?.line_items, "product");
            replenishmentLineItems = _.filter(working.order.payload?.line_items, (li) => counts[li.product] > 1);
        }

        const lineItems = _.intersectionWith(replenishmentLineItems, productIds, (li, id) => li.product === id);

        if (!_.isEmpty(lineItems) && !working.order.isFetching) {
            dispatch({
                type: WORKING_ORDER.LOAD_INVENTORY,
                payload: {
                    lineItems,
                    availabilityMap: null, // TODO: add intersection with warehouses available to delivery windows in WO
                    warehouses: getCompanyWarehouses(working.company.payload, scope),
                },
                meta: {
                    ...meta,
                    adjust: true,
                    forceNotify: true,
                },
            });
        }
    };

export const clearAvailabilityCache = () => ({
    type: WORKING_ORDER.AVAILABILITY.PRODUCTS_CACHE.CLEAR,
});
